import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2163512699/src/neroom-website/components/FAQ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2163512699/src/neroom-website/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2163512699/src/neroom-website/components/Header.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2163512699/src/neroom-website/node_modules/next/dist/client/script.js");
